<template>
  <v-container v-if="links" class="text-center hidden-xs-only">
    <template v-for="(l, i) in links">
      <v-chip outlined v-if="l.gateResult" :key="i" :to="l.href" link class="mr-2 mb-2">
        <v-icon left>{{ l.icon }}</v-icon>
        {{ $t(l.text) }}
      </v-chip>
    </template>
  </v-container>
</template>

<script lang="ts">
import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class NavChips extends mixins() {
  @Prop({ required: true })
  links?: Array<any>;
}
</script>
